<template>
  <div>
    <Header />
    <div class="c-standard-content">
      <div class="c-standard-list-bx">
        <h2>共同起草报名</h2>
        <ul class="c-standard-list">
          <li>
            <p class="c-standard-lf-txt">标准名称： </p>
            <div class="c-standard-rt-input">
              <input type="text" maxlength="18" placeholder="标准名称" v-model="standardName" disabled="false">
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt">机构名称：</p>
            <div class="c-standard-rt-input">
              <input type="text" maxlength="18" placeholder="机构名称" v-model="organization">
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt">联系人：</p>
            <div class="c-standard-rt-input">
              <input type="text" maxlength="18" placeholder="联系人" v-model="contacts">
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt">联系电话：</p>
            <div class="c-standard-rt-input">
              <input type="text" maxlength="18" placeholder="联系电话" v-model="mobile">
            </div>
          </li>
          <li>
            <p class="c-standard-lf-txt">报名表：</p>
            <div class="c-standard-rt-input">
              <Upload style="display: inline-block;" v-on:resetImageName="resetCloudProtocol1" btnText="" accept="image/jpeg,image/png,application/pdf">
                <button class="submit-btn">上传报名表</button>
              </Upload>
              <a href=""><span class="download-agreement">下载报名表<img src="../../assets/main/xiazai.png"></span></a>
              <div class="c-business-license">
                <p class="c-tips3">{{attachment&&attachment[0].name}}</p>
              </div>
            </div>
          </li>
        </ul>
        <div class="btnbox">
          <button class="cancel-btn" @click="$router.back(-1)">取消</button>
          <button class="submit-btn" @click="sigUpStandard">提交</button>
        </div>
      </div>
    </div>
    <Footer :isLogin="true" />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue';
  import Footer from '@/components/Footer.vue';
  import Upload from '@/components/common/Upload';
  import config from '@/config/index';
  import{addStandardApply} from '@/api/standard.js'
  import {
    getCacheUserInfo
  } from '@/utils/auth'
  export default {
    name: 'standardSigup',
    components: {
      Header,
      Footer,
      Upload,
    },
    watch: {
      $route(to, from) {

      }
    },
    mounted() {
      this.sid = this.$route.query.sid
      this.standardName = this.$route.query.sname
    },
    data() {
      return {
        sid: "",
        standardName: "",
        organization: "",
        contacts: '', //联系人
        mobile: '', //手机号
        attachment: ''
      }
    },
    computed: {

    },
    methods: {
      getUid() {
        const userInfo = getCacheUserInfo();
        const uid = userInfo && userInfo.uid;
        return uid;
      },
      sigUpStandard() {
        let params = {
          sid: this.sid, //标准ID
          uid: this.getUid(), //用户id
          organization: this.organization, //组织机构
          mobile:this.mobile,       //联系电话
          contacts:this.contacts,     //联系人
          applytable:JSON.stringify(this.attachment)   //报名表
        }
        console.log("params-->", params)
        // return
        this.$http.post(addStandardApply(), params).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.$message.success('信息提交成功，等待审核');
          }
        });
      },
      resetCloudProtocol1(key) {
        const protocol = [{
          name: key,
        }];
        this.attachment = protocol;
      },

    }
  }
</script>

<style>
  @import url(./StandardCreate.css);

  .price-negotiation {
    float: left;
  }

  .c-standard-rt-input input.checkbox {
    width: 18px;
    height: 18px;
    margin: 9px;
  }

  .file-btn {
    position: relative;
  }

  .file-btn__upload {
    position: absolute;
    width: 1.2rem;
    height: 1.2rem;
  }

  .file-btn__upload-btn {
    width: 1.2rem;
    height: 1.2rem;
    display: inline-block;
  }

  .download-agreement {
    color: #267FF2;
    padding-left: 20px;
    cursor: pointer;
  }

  .download-agreement img {
    vertical-align: 0px;
    margin-left: 7px;
  }

  .c-business-license {
    margin-top: 20px;
  }

  .c-business-license img {
    width: 60px;
    height: auto;
    margin: 0;
  }

  .c-tips3 {
    font-size: 12px;
    line-height: 20px;
    color: #267FF2;
  }
</style>
